module.exports={
    "global": ["nonEcommerce"],
    "storefront": ["promotionImpression"],
    "search": ["productImpression"],
    "clp": ["productImpression"],
    "product": ["productDetail"],
    "checkout": ["checkout"],
    "cart": ["checkout"],
    "orderconfirmation": ["purchase"]
}